import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Thumb/ShopEditor';
import s from './Commission.scss';
const CommissionThumbReactView = (props)=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(MinimalDumbo, _object_spread_props(_object_spread({}, props), {
        addLink: false
    })));
CommissionThumbReactView.displayName = 'CommissionThumbReactView';
export default CommissionThumbReactView;

//# sourceMappingURL=Commission.js.map